import { render, staticRenderFns } from "./AnswerImage.vue?vue&type=template&id=c25c8a90&scoped=true"
import script from "./AnswerImage.vue?vue&type=script&lang=js"
export * from "./AnswerImage.vue?vue&type=script&lang=js"
import style0 from "./AnswerImage.vue?vue&type=style&index=0&id=c25c8a90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25c8a90",
  null
  
)

export default component.exports